// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__157qP","header":"PatientQuestionnaire_header__308lu","info":"PatientQuestionnaire_info__242r4"};